import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal, Table, Tooltip } from 'antd';
import Column from 'antd/es/table/Column';
import Title from 'antd/es/typography/Title';
import DownloadComponent from 'components/Global/Download';
import Ellipse from 'components/Global/Ellipse';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { formatDate, formatNumber, invalidText } from 'utils/utils';
import './index.scss';

type HistoryProps = {
	open: boolean;
	closeModal: () => void;
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	allNapsaData: any;
	isLoading: boolean;
};

const ShareComponent = (data: any) => {
	const { record } = data;

	return (
		<Tooltip
			title={
				<>
					<p>EmployeeShare : {record.employeeShare} %</p>
					<p>EmployerShare : {record.employerShare} %</p>{' '}
				</>
			}
			placement="right"
		>
			{record.employerShare + record.employeeShare} %
		</Tooltip>
	);
};
const HistoryModal = (props: HistoryProps) => {
	const {
		open,
		closeModal,
		totalRecords,
		currentPage,
		pageSize,
		tableChangeHandler,
		allNapsaData,
		isLoading,
	} = props;

	const { data } = useSelector((state: any) => state?.userProfile);


	const { data: profileData } = useSelector(
		(state: any) => state?.userProfile
	);
	const renderDeductionAgeDetails = (record: any) => {
		const details = (
			<div>
				<p>
					<strong>Deduction limit :</strong>{' '}
					{record.napsaDeductionLimit
						? formatNumber(
								Number(record.napsaDeductionLimit),
								data?.CompanyCurrencies
						  )
						: '-'}
				</p>
				<p>
					<strong>Age limit :</strong> {record.ageLimit} years
				</p>
			</div>
		);

		return (
			<Tooltip title={details}>
				<Button type="link" style={{ color: '#584495' }}>
					View Details
				</Button>
			</Tooltip>
		);
	};

	return (
			<Modal
				// title="History"
				open={open}
				// onCancel={closeModal}
				maskClosable={true}
				width={1000}
				closable={false}
				footer={null}
				rootClassName="napsaModalRoot"
			>
				<div className="modal-header">
					<Title level={4} className="modal-title">
						History
					</Title>
					<div className="close-icon" onClick={closeModal}>
						<CloseOutlined />
					</div>
				</div>

				<Table
					dataSource={allNapsaData}
					pagination={{
						total: totalRecords,
						current: currentPage,
						pageSize: pageSize,
						showSizeChanger: false,

						pageSizeOptions: [10, 20, 50, 100, 200],
					}}
					onChange={tableChangeHandler}
					rowKey={(record) => record.id}
					loading={isLoading}
				>
					<Column
						title="Effective Date"
						dataIndex="effectiveDate"
						key="effectiveDate"
						sorter={true}
						className="bg-white"
						render={(value) => {
							return formatDate(
								value,
								profileData?.companyDateFormat ?? 'DD/MM/YYYY'
							);
						}}
					/>
					<Column
						title="Percentage Share"
						key="employeeShare"
						dataIndex="employeeShare"
						className="bg-white"
						render={(_, record: any) => (
							<ShareComponent record={record} />
						)}
					/>
					<Column
						title="Updated By"
						dataIndex="createdBy"
						key="createdBy"
						className="bg-white"
						render={(text) => text?.fullName}
					/>
					<Column
						title="Deduction Limit"
						dataIndex="napsaDeductionLimit"
						key="napsaDeductionLimit"
						className="bg-white"
						width={'18%'}
						render={(value: string) => {
							return formatNumber(
								Number(value),
								data?.CompanyCurrencies
							);
						}}
					/>
					<Column
						title="Notes"
						dataIndex="notes"
						key="notes"
						sorter={true}
						className="bg-white"
						render={(text) =>
							invalidText(text) ? (
								'-'
							) : (
								<Ellipse
									message={text}
									maxLength={20}
									key={text}
									tooltipMessage={text}
									isTooltip={true}
								/>
							)
						}
					/>
					<Column
						title="Attachment"
						dataIndex="attachment"
						key="attachment"
						className="bg-white"
						width={'18%'}
						render={(text, record: any) => (
							<div>
								{record.documentName ? (
									<div>
										<DownloadComponent
											documentUrl={record.documentUrl}
											downloadText={record.documentName}
											showTooltip={true}
											text={record.documentName}
											isLink={true}
											maxLength={20}
										/>
									</div>
								) : (
									'-'
								)}
							</div>
						)}
					/>
					<Column
						title="Other Details"
						dataIndex="createdAt"
						key="createdAt"
						className="bg-white"
						width={'16%'}
						render={(text, record: any) =>
							renderDeductionAgeDetails(record)
						}
					/>
				</Table>
			</Modal>
	);
};

export default HistoryModal;
